import {Component, effect, inject, input, signal} from '@angular/core';
import {SpinnerComponent} from "src/app/presentation/common/spinner/spinner.component";
import {lastSeenWithinThreshold} from "src/app/presentation/common/asset-details.component";
import {WaterPointSvgComponent} from "src/app/presentation/common/icons/water-point-svg/water-point-svg.component";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";
import {SynchronizationStatus, WaterPoint} from "src/app/infrastructure/moovement-api/models/asset";
import {timeAgo} from 'src/app/domain/util/timestamps/timestamps';
import {toWaterPointValueColorClass} from 'src/app/domain/assets/water-points/water-point';
import {WaterPointsStore} from 'src/app/domain/assets/water-points/water-points.store';
import {Router} from '@angular/router';

@Component({
  selector: 'app-water-point-button',
  imports: [
    SpinnerComponent,
    WaterPointSvgComponent
  ],
  templateUrl: './water-point-button.component.html',
  styleUrl: './water-point-button.component.css'
})
export class WaterPointButtonComponent {

  id = input.required<string>();

  asset = signal<WaterPoint | undefined>(undefined);
  focusable = false;
  lastAssetSample = signal<Samples.AssetSample<any> | undefined>(undefined);
  isLastSeenWithinThreshold = signal(false);
  loading = true;
  percentage: string = "";
  statusMessage = signal('Last seen: ?');
  statusMessageColorClass = signal('color-danger');
  valueColorClass: string = 'color-primary-information';

  SynchronizationStatus = SynchronizationStatus;

  private router = inject(Router);
  private waterPointsStore = inject(WaterPointsStore);

  constructor() {
    effect(() => {
      const lastSample = this.lastAssetSample();
      this.valueColorClass = toWaterPointValueColorClass(lastSample);
      this.percentage = `${lastSample?.sample?.value || '0'}%`
    });

    effect(() => {
      this.loading = this.waterPointsStore.loading();
    });

    effect(() => {
      const assetId = this.id();
      if (!assetId) return;

      this.asset.set(this.waterPointsStore.entityMap()[assetId]);
    });

    effect(() => {
      this.createMessage();
    });

    effect(() => {
      const waterPoint = this.asset();
      if (!waterPoint) return;

      const assetSamples = this.waterPointsStore.assetSamples().get(waterPoint);
      if (!assetSamples || assetSamples.length === 0) return;

      const lastAssetSample = assetSamples.at(0);
      this.lastAssetSample.set(lastAssetSample);
      this.isLastSeenWithinThreshold.set(this.lastSeenWithinThreshold(assetSamples));
    });
  }

  protected createMessage() {
    const lastAssetSample = this.lastAssetSample();
    if (!lastAssetSample) {
      this.statusMessage.set("Last measurement: ?");
      return;
    }

    const isSeenWithinThreshold = this.isLastSeenWithinThreshold();
    if (!isSeenWithinThreshold) {
      this.statusMessageColorClass.set("color-danger");
      this.statusMessage.set(`Last measurement: ${timeAgo(new Date(lastAssetSample.sample!.instant!))}`);
    } else {
      this.statusMessageColorClass.set("color-primary-information");
      this.statusMessage.set(`Last measurement: ${timeAgo(new Date(lastAssetSample.sample!.instant!))}`);
    }
  }

  lastSeenWithinThreshold(assetSamples: Samples.AssetSample<any>[]) {
    return lastSeenWithinThreshold(assetSamples, 'WaterLevel');
  }

  focus() {
    this.router.navigate(['/main/water-point-details', this.id()]);
  }
}
